import React, {useState} from 'react';

import '../Tutorial.css';
import Typewriter from "typewriter-effect";
import TutorialGirl from "../TutorialGirl";
import {useActions} from "../../../hooks/useActions";

function T210ArenaDaily() {
    const {setTutorial} = useActions();

    const text = 'Daily Quests are your main source of Gems. Don’t miss them';
    const [showNext, setShowNext] = useState(false);
    const atEnd = () =>{
        setShowNext(true);
    }

    return <div>

        <div className={'T200Left'}></div>
        <div className={'T200Right'}></div>
        <div className={'T150Bottom'}></div>

        <TutorialGirl position={'Right'} undressingProcess={3}/>
        <div className='tutorialContainer tutorialTopContainer210'>
            <div className='tutorialBottomTextField'>
                <Typewriter
                options={{
                    delay: 30
                }}
                onInit={(typewriter) => {
                    typewriter.typeString(text).start().callFunction(atEnd);
                }}
            />
            </div>
            {(showNext)?
                <div className={'tutorialButton defaultButtonAnimation'} onClick={() => {
                    setTutorial({isActive: true, step: 'ArenaChampion220'});
                }}>
                </div>
                : <div className={'tutorialButtonPlaceholder'}></div>
            }
        </div>
    </div>
}

export default T210ArenaDaily;